<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header" style="height: 0; padding: 0">
      <a (click)="close()" class="cstm-close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <div class="modal-body d-flex flex-column p-4">
      <div class="flex-fill">
        <div class="d-flex mb-3">
          <div class="flex-fill d-flex gap-3">
            <app-avatar [size]="40" class="bg-secondary-primary text-primary shadow border">
              <i class="cs-icon cs-icon-ai"></i>
            </app-avatar>
            <div>
              <div class="text-xxl" [ngClass]="isEmpty ? 'text-xxl' : 'text-xl'">Hello {{ userName }}</div>
              <div class="text-muted" [ngClass]="isEmpty ? '' : 'text-sm'">
                <ng-container i18n>How can I assist you today?</ng-container>&nbsp;
                <app-page-help articleId="vgid2towSx1HARqbtdkDQB"></app-page-help>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center gap-3">
            <button
              class="btn btn-cirlce btn-light-info shadow-sm"
              matTooltip="New Chat"
              i18n-matTooltip
              (click)="onNewChat()"
            >
              <i class="fas fa-plus"></i>
            </button>
            <button
              class="btn btn-cirlce btn-light-danger shadow-sm"
              matTooltip="Delete current chat"
              i18n-matTooltip
              (click)="onDeleteChat(currentChatId)"
              *ngIf="currentChatId"
            >
              <i class="cs-icon cs-icon-trash"></i>
            </button>
            <div class="btn-group" dropdown [isDisabled]="!chats?.length">
              <button
                class="btn btn-cirlce btn-light-info shadow-sm dropdown-toggle"
                dropdownToggle
                matTooltip="The history will maintain only one time for one chat"
                i18n-matTooltip
              >
                <i class="cs-icon cs-icon-time-back"></i>
              </button>
              <ul
                *dropdownMenu
                class="dropdown-menu dropdown-menu-right"
                style="max-height: 500px; max-width: 400px; overflow-y: auto"
              >
                <ng-container *ngFor="let group of groupedChats">
                  <li class="dropdown-header px-2 text-muted text-semi-bold" style="opacity: 0.5">{{ group.key }}</li>
                  <li *ngFor="let chat of group.value">
                    <button type="button" (click)="onViewChat(chat.id)">
                      <div class="text-truncate">{{ chat.title }}</div>
                    </button>
                  </li>
                </ng-container>
                <li class="dropdown-header p-0" *ngIf="!isHistoryExpanded">
                  <a
                    (click)="$event.stopPropagation(); onExpandHistory()"
                    href="javascript:void(0)"
                    class="text-info text-semi-bold"
                  >
                    <span i18n>View all history</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <ng-template [ngTemplateOutlet]="suggestions" *ngIf="isEmpty"></ng-template>

        <div class="d-flex flex-column mt-3">
          <ng-container *ngTemplateOutlet="messagesTmpl; context: { messages: messages }"></ng-container>
          <div class="text-center mt-4" *ngIf="isLoading">
            <i class="fas fa-spinner-scale fa-spin-pulse text-xxl"></i>
          </div>
        </div>
      </div>
      <div class="mt-3">
        <mat-form-field2 class="mat-block" [showLabel]="false">
          <input
            type="text"
            matInput
            placeholder="Try a voice command or Type here"
            [formControl]="messageCtrl"
            (keyup.enter)="onSend(messageCtrl)"
            [disabled]="isLoading"
            required
          />
          <a matPrefix voiceRecord #recorder="voiceRecord" (voice)="onVoice($event)" [class.disabled]="isLoading">
            <i
              class="fas fa-microphone text-info"
              *ngIf="!recorder.isRecording"
              matTooltip="Voice to text"
              i18n-matTooltip
            ></i>
            <i class="fas fa-dot-circle text-danger fa-beat-fade" *ngIf="recorder.isRecording"></i>
          </a>
          <a matSuffix (click)="onSend(messageCtrl)" [class.disabled]="isLoading">
            <i class="cs-icon cs-icon-paper-plane-h text-info" *ngIf="!isLoading"></i>
            <i class="far fa-spinner fa-spin text-info" *ngIf="isLoading"></i>
          </a>
        </mat-form-field2>
      </div>
    </div>
  </div>
</div>

<ng-template #messagesTmpl let-items="messages">
  <ng-container *ngFor="let item of items">
    <div *ngIf="item.role === roles.Assistant" class="mt-4">
      <ng-container *ngTemplateOutlet="aiMessage; context: { message: item }"></ng-container>
    </div>
    <div *ngIf="item.role === roles.System">
      <ng-container *ngTemplateOutlet="systemActions; context: { messages: [item] }"></ng-container>
    </div>

    <div *ngIf="item.role === roles.User" class="mt-4">
      <ng-container *ngTemplateOutlet="userMessage; context: { message: item }"></ng-container>
    </div>

    <!-- Only system messages are grouped -->
    <div *ngIf="item.length > 0">
      <ng-container *ngTemplateOutlet="systemActions; context: { messages: item }"></ng-container>
    </div>
  </ng-container>
</ng-template>

<ng-template #userMessage let-message="message">
  <div class="d-flex gap-3">
    <div [style.width.px]="avatarSize"></div>
    <div class="flex-fill">
      <div *ngIf="message.timestamp" class="text-muted text-xs">{{ message.timestamp | epoch : 'datetime' }}</div>
      <div class="px-3 py-2 bg-active rounded border" style="border-top-right-radius: 0 !important">
        <div>{{ message.content }}</div>
      </div>
    </div>
    <app-avatar [text]="userName" [size]="avatarSize"></app-avatar>
  </div>
</ng-template>

<ng-template #aiMessage let-message="message">
  <div class="d-flex gap-3">
    <app-avatar [size]="avatarSize" class="bg-secondary-primary text-primary shadow border">
      <i class="cs-icon cs-icon-ai"></i>
    </app-avatar>
    <div class="flex-fill">
      <div *ngIf="message.timestamp" class="text-muted text-xs text-right">
        {{ message.timestamp | epoch : 'datetime' }}
      </div>
      <div class="px-3 py-2 bg-white rounded border" style="border-top-left-radius: 0 !important">
        <div [innerHTML]="message.contentHtml"></div>
      </div>
    </div>
    <div [style.width.px]="avatarSize"></div>
  </div>
</ng-template>

<ng-template #systemActions let-messages="messages">
  <div class="d-flex gap-3">
    <div [style.width.px]="avatarSize"></div>
    <div class="p-1 entity-actions">
      <ng-container *ngFor="let message of messages">
        <ng-container *ngFor="let item of message.metadata; let count = count">
          <ng-container *ngIf="count < 2">
            <a (click)="onViewEntity(item.type, item.entity)" *ngIf="isViewable | call : item.action"
              >View {{ (item.type === 'calendar' ? 'Hold Event' : item.type) | titleCase }}</a
            >
            <a (click)="onDeleteEntity(item.type, item.entity)" *ngIf="isDeletable | call : item.type : item.action"
              >Delete {{ (item.type === 'calendar' ? 'Hold Event' : item.type) | titleCase }}</a
            >
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #suggestions>
  <div class="d-flex flex-column gap-3">
    <button
      type="button"
      class="btn btn-outline-light justify-content-start"
      (click)="onSuggestMessage(item)"
      *ngFor="let item of suggestionQuestions"
    >
      <i class="cs-icon cs-icon-ai-blink text-primary"></i> {{ item }}
    </button>
  </div>
</ng-template>
